<div class="sp-page">
  <app-navbar [backurl]="'panel/pricing'" [enableBack]="true"></app-navbar>

  <div class="sp-body">

    <!-- Loading spinner -->
    <div class="sp-loading" *ngIf="!load">
      <mat-spinner [diameter]="40"
        style="--mdc-circular-progress-active-indicator-color:#c9a84c;"></mat-spinner>
      <p class="sp-loading-text">Setting up your payment form…</p>
    </div>

    <!-- Error state -->
    <div class="sp-error-card" *ngIf="load && error">
      <div class="sp-error-icon"><mat-icon>error_outline</mat-icon></div>
      <h2 class="sp-error-title">Payment unavailable</h2>
      <p class="sp-error-msg">{{error}}</p>
      <a routerLink="/panel/pricing" class="sp-error-btn">Back to Pricing</a>
    </div>

    <!-- Stripe checkout + cancel button -->
    <div class="sp-checkout-wrap" *ngIf="load && !error">
      <button class="sp-cancel-btn" (click)="cancel()" title="Cancel payment">
        <mat-icon>close</mat-icon>
      </button>
      <div id="checkout"></div>
    </div>

  </div>
</div>
